import styled from 'styled-components';
import classNames from 'classnames';
import Circle from '../circle';
import { CircleProps } from '../circle/circle';
import { badge } from './style';

export interface AvatarBadgeProps extends CircleProps {
  placement?: keyof typeof badge.placements;
  className?: string;
}

const AvatarBadge = styled(({ className, placement, ...rest }: AvatarBadgeProps) => (
  <Circle className={classNames('avatar-badge', className, placement)} {...rest} />
))<AvatarBadgeProps>`
  position: absolute;
  ${props => badge.placements[props.placement || 'bottom-right']};
`;

export default AvatarBadge;
